export const MIGRATION_SOURCES = [
  {
    id: 'IMAP',
    name: 'Generic IMAP',
    icon: null,
    description: 'Any IMAP server — Plesk, Dovecot, Zimbra, Rackspace, self-hosted',
    supportsUserEnum: true,
    credentialFields: ['hostname', 'username', 'password', 'port']
  },
  {
    id: 'CPANEL',
    name: 'cPanel / WHM',
    icon: '/migration/CPanel.webp',
    description: 'Migrate from cPanel-based email hosting',
    supportsUserEnum: true,
    credentialFields: ['hostname', 'username', 'password', 'port']
  },
  {
    id: 'TITAN',
    name: 'Titan Mail',
    icon: '/migration/titan.webp',
    description: 'Migrate from Titan Email (Flock Mail)',
    supportsUserEnum: true,
    credentialFields: ['hostname', 'username', 'password', 'port']
  },
  {
    id: 'MS_EXCHANGE',
    name: 'Microsoft 365',
    icon: '/migration/Microsoft_Exchang.webp',
    description: 'Migrate from Office 365 / Exchange Online',
    supportsUserEnum: true,
    authMethod: 'oauth',
    oauthProvider: 'microsoft',
    credentialFields: []
  },
  {
    id: 'GSUITE',
    name: 'Google Workspace',
    icon: '/migration/Gmail.webp',
    description: 'Migrate from Gmail / Google Workspace',
    supportsUserEnum: true,
    authMethod: 'oauth',
    oauthProvider: 'google',
    credentialFields: []
  },
  {
    id: 'YAHOO',
    name: 'Yahoo Mail',
    icon: '/migration/Yahoo!_Mail.svg',
    description: 'Migrate from Yahoo Mail / Yahoo Business',
    supportsUserEnum: false,
    credentialFields: ['adminEmail', 'adminPassword']
  },
  {
    id: 'ZOHO',
    name: 'Zoho Mail',
    icon: '/migration/Zoho_Mail.webp',
    description: 'Migrate from Zoho Mail',
    supportsUserEnum: true,
    credentialFields: ['adminEmail', 'adminPassword', 'domain']
  }
];

export const WIZARD_STEPS = {
  individual: [
    { id: 'source', label: 'Source', description: 'Select email provider' },
    { id: 'method', label: 'Method', description: 'Migration type' },
    { id: 'connection', label: 'Connect', description: 'Enter credentials' },
    { id: 'domains', label: 'Domains', description: 'Map domains' },
    { id: 'users', label: 'Users', description: 'Select users' },
    { id: 'validation', label: 'Validate', description: 'Check sizes' },
    { id: 'review', label: 'Review', description: 'Confirm & start' }
  ],
  bulk: [
    { id: 'source', label: 'Source', description: 'Select email provider' },
    { id: 'method', label: 'Method', description: 'Migration type' },
    { id: 'csv', label: 'CSV Upload', description: 'Upload user list' },
    { id: 'validation', label: 'Validate', description: 'Check sizes' },
    { id: 'review', label: 'Review', description: 'Confirm & start' }
  ]
};

export const STATUS_VARIANTS = {
  pending: 'gray',
  running: 'orange',
  completed: 'success',
  failed: 'error',
  cancelled: 'warning',
  paused: 'info'
};

export const CSV_TEMPLATE_COLUMNS = [
  'email',
  'password',
  'hostname',
  'port',
  'use_ssl',
  'source_domain',
  'target_domain'
];

export const CSV_TEMPLATE_ROW = [
  'user@example.com',
  'password123',
  'imap.example.com',
  '993',
  'true',
  'example.com',
  'yourdomain.com'
];
